import { render, staticRenderFns } from "./LichSuLuuTruForm.vue?vue&type=template&id=06b2cdc6"
import script from "./LichSuLuuTruForm.vue?vue&type=script&lang=js"
export * from "./LichSuLuuTruForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuLuuTruForm.vue?vue&type=style&index=0&id=06b2cdc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports